import { format, isValid, parseISO } from 'date-fns'
import { isEmpty } from 'lodash'

export default function formatUTCAsLocalTime(dateString) {
  // Convert that UTC value of dateString to the viewer’s local time
  if (isEmpty(dateString)) return

  const date = parseISO(dateString)
  // Some API fields arrive already formatted (e.g. "10/09/26"), which
  // parseISO cannot read. Show those as-is rather than throwing.
  if (!isValid(date)) return dateString

  return format(date, 'p')
}
